<template>
<div id="content">
    <div class="container" id="about">
        <div class="row">
            <div class="col-md-3 sidebar visible-md-block visible-lg-block">
                <TheSidebar v-bind:routes="childRoutes"></TheSidebar>
            </div>

            <div class="col-md-9">
                <router-view></router-view>
            </div>
        </div>
     </div>
</div>
</template>

<script>
import TheSidebar from "@/components/layout/TheSidebar";

export default {
  name: "AboutUs",
  components: { TheSidebar },
  data: function() {
    return {
      childRoutes: [
        { label: "About Us", routeName: "AboutUsPage" }
      ]
    };
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/AboutUs.vue